import {handleActions} from 'redux-actions';
import {createReducer} from "../baseReducer/baseReducer";


// ------------------------------------
// Constants
// ------------------------------------

export const { reducers, initialState, actions } = createReducer(
    "empleados",
    "empleados",
    "EmpleadosForm",
    "/empleados",
);

export default handleActions(reducers, initialState);
